export const sanitizeContent = (content: string) => {
    // Remove all empty tags or unnecessary whitespace
    const doc = new DOMParser().parseFromString(content, 'text/html');

    // Optionally, sanitize the document further by removing any script tags or unwanted elements
    const scripts = doc.querySelectorAll('script');
    scripts.forEach(script => script.remove());

    let textContent = doc.body.textContent?.trim(); // Use 'let' to allow reassignment

    // Remove unwanted line breaks or excess spaces
    if (textContent) {
      textContent = textContent.replace(/\n+/g, ' ').replace(/\s{2,}/g, ' '); // Replace new lines and extra spaces with a single space
    }

    return textContent;
  };


  export const removeSpacing = (description: string): string => {
  return description
    .replace(/<p((?![^>]*style=)[^>]*)>/g, '<p style="margin:0 !important"$1>')
    .replace(/<ol((?![^>]*style=)[^>]*)>/g, '<ol style="margin:0 !important"$1>')
    .replace(/<ul((?![^>]*style=)[^>]*)>/g, '<ul style="margin:0 !important"$1>')
    .replace(/<h1((?![^>]*style=)[^>]*)>/g, '<h1 style="margin:0 !important"$1>')
    .replace(/<h2((?![^>]*style=)[^>]*)>/g, '<h2 style="margin:0 !important"$1>')
    .replace(/<h3((?![^>]*style=)[^>]*)>/g, '<h3 style="margin:0 !important"$1>')
    .replace(/<h4((?![^>]*style=)[^>]*)>/g, '<h4 style="margin:0 !important"$1>')
    .replace(/<h5((?![^>]*style=)[^>]*)>/g, '<h5 style="margin:0 !important"$1>')
    .replace(/<h6((?![^>]*style=)[^>]*)>/g, '<h6 style="margin:0 !important"$1>');
};